import { LocationVarKey } from "@swivl-mono/types";

import { PageHeader, SectionHeader, TextAreaRow } from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.QuickReplyGreeting,
  LocationVarKey.QuickReplyClosing,
  LocationVarKey.QuickReplyGoogleReview,
  LocationVarKey.QuickReplyUsage,
  LocationVarKey.QuickReplyStoring,
  LocationVarKey.QuickReplyWhen,
  LocationVarKey.QuickReplyUnderstandFeature,
  LocationVarKey.QuickReplyUnderstandSize,
  LocationVarKey.QuickReplyCheckInventory,
  LocationVarKey.QuickReplyPhoneNumber1,
  LocationVarKey.QuickReplyPhoneNumber2,
  LocationVarKey.QuickReplyMove2Text,
  LocationVarKey.QuickReplyReservation,
  LocationVarKey.QuickReplyWhatElse
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        👋 Greeting{" "}
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyGreeting} />
      <SectionHeader {...page}>🚪 Closing</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyClosing} />
      <SectionHeader {...page}>👍 Google Review</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyGoogleReview} />
      <SectionHeader {...page}> 🏠 Usage</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyUsage} />
      <SectionHeader {...page}>❓ Storing?</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyStoring} />
      <SectionHeader {...page}>📆 When and How Long?</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyWhen} />
      <SectionHeader {...page}>🏝️ Feature?</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyUnderstandFeature} />
      <SectionHeader {...page}>📏 Size?</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyUnderstandSize} />
      <SectionHeader {...page}>🛒 Check Inventory</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyCheckInventory} />
      <SectionHeader {...page}>📞 Collect Phone Number</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyPhoneNumber1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.QuickReplyPhoneNumber2} />
      <SectionHeader {...page}>📲 Move to Text</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyMove2Text} />
      <SectionHeader {...page}> 🆓 Free Reservation</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyReservation} />
      <SectionHeader {...page}>🧐 What Else?</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.QuickReplyWhatElse} />
    </>
  );
}
